/** A tiny className joiner — the brief calls for hand CSS / no component
 *  library, so this replaces a `clsx` dependency with the ~6 lines it needs. */
export default function clsx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
